// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Yi_H","comment":"styles_comment__1bTs8"};